/**
 * BorrowerCapacityUtilizationChart — NOT_CONNECTED
 *
 * Capacity utilization data requires LOS integration.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const BorrowerCapacityUtilizationChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.los}
      metricName="Borrower Capacity Utilization"
    />
  );
};

export default BorrowerCapacityUtilizationChart;